<template>
  <div class="container">
    <div class="loginMain">
      <el-row>
        <el-col :span="7">
          <div class="leftImg">
            <div class="imgBox">
              <img src="../../assets/images/loginbg.png"/>
            </div>
          </div>
        </el-col>
        <el-col :span="17">
          <div class="rightForm">
            <div class="formMain">
              <div class="formBox">
                <h1 style="text-align: center">登录</h1>
                <el-form :model="form" :rules="rules" ref="form">
                  <el-form-item prop="name">
                    <el-input v-model="form.name" placeholder="请输入用户名">
                      <i slot="prefix" class="el-input__icon el-icon-user-solid"></i>
                    </el-input>
                  </el-form-item>
                  <el-form-item prop="password">
                    <el-input v-model="form.password" placeholder="请输入密码" type="password">
                      <i slot="prefix" class="el-input__icon el-icon-lock"></i>
                    </el-input>
                  </el-form-item>
                </el-form>
                <div class="remember">
                  <el-checkbox >记住密码</el-checkbox>
                </div>
                <div slot="footer" class="subBtn">
                  <el-button type="primary" @click="submitForm">确 定</el-button>
<!--                  <div class="textBox">-->
<!--                    <span>还没账号？<span>立即注册</span></span>-->
<!--                  </div>-->
                </div>
                <div class="regiester">
                  <span>还没账号？</span>
                  <span
                    style="color:#3963AE;cursor: pointer"
                    @click="goReigester"
                  >立即注册</span>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      rules:{
        name:[{ required: true, message: "用户名不能为空", trigger: "blur" }],
        password:[{ required: true, message: "密码不能为空", trigger: "blur" }],
      },
      form:{}
    }
  },
  methods:{
    goReigester(){
      this.$router.push('/pull/regiester')
    },
    submitForm(){
      this.$refs['form'].validate(valid => {
        if (valid) {
          localStorage.setItem('loginStatus',1)
          setTimeout(()=> {
            this.$router.push('/home/index')
            this.$EventBus.$emit("setTitleStyle")
            this.$EventBus.$emit("setClass")
            this.$EventBus.$emit("handleLogin")
          },500)
        }
      })
    }
  }
}
</script>

<style scoped>
  .loginMain{
    width: 100%;
    height: 925px;
    background: #ffffff;
  }
  .leftImg{
    width: 100%;
    height: 925px;
    background: #3963AE;
    position: relative;
  }
  .rightForm{
    width: 100%;
    height: 925px;
    background: #f8f9fb;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .rightForm .formMain{
    width: 600px;
    min-height: 600px;
    padding: 60px 120px;
    box-sizing: border-box;
    box-shadow: 0 12px 60px -20px rgba(128,137,158,.4);
    border-radius: 16px;
  }
  .rightForm .formMain .formBox{
    width: 100%;
    min-height: 200px;
  }
  .rightForm .formMain .formBox h1{
    margin: 0;
    font-size: 32px;
    line-height: 38px;
    margin-bottom: 42px;
    color: #000000;
    font-weight: 500;
    font-family: 'PingFang SC', 'PingFang SC-Bold';
  }
  .imgBox{
    position: absolute;
    top: 20%;
  }
  .imgBox img{
    width: 100%;
    height: auto;
  }
  .subBtn{
    width: 100%;
    text-align: right;
  }
  .subBtn button{
    width: 100%;
  }
  .subBtn span{
    font-size: 12px;
  }
  .textBox{
    display: inline-block;
    position: relative;
    top: 10px;
  }
  .remember{
    width: 100%;
    height: 20px;
    margin-bottom: 22px;
  }
  .regiester{
    width: 100%;
    height: 20px;
    margin-top: 22px;
  }
  .regiester span{
    font-size: 14px;
  }

</style>
